export default __webpack_public_path__ + "static/3p_2-246a47e481f3f1f7d9a044f9a4994a36.jpg";